import { $ } from '../utils';

// Sticky header component
const StickyHeader = () => {
    // Getting header
    const header = $('#header');

    // Adding scroll event listener
    window.addEventListener("scroll", () => {
        // Checking scrolled height
        window.scrollY > 100 ?
            // Adding sticky class to header
            header.addClass('sticky') :
            // Adding sticky class to header
            header.removeClass('sticky');
    });
};

// Export component
export default StickyHeader;